import { render, staticRenderFns } from "./BaiDuMap.vue?vue&type=template&id=d8bfbe3a"
import script from "./BaiDuMap.vue?vue&type=script&lang=js"
export * from "./BaiDuMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports